__turbopack_context__.v({
  "app_light_theme": "product-spec-item-module-scss-module__dcLNna__app_light_theme",
  "specItem": "product-spec-item-module-scss-module__dcLNna__specItem",
  "specItem--underLine": "product-spec-item-module-scss-module__dcLNna__specItem--underLine",
});
